import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import TextButton from '@/components/Buttons/TextButton.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'TheMediaNavigation',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TextButton, {
    title: "Media Player",
    link: "/media",
    id: "media-subnavigationTitle"
  }))
}
}

})